import React from 'react';
import styles from './Footer.module.scss';

const Footer: React.FC = () => (
  <div className={styles.Footer} data-testid="Footer">
    <div className={styles.container}>
      <strong>Lot Archive</strong>
    </div>
    <div className={styles.container}>
      <p className={styles.copyright}>copyright - Heinrich Köhler Auktionen</p>
    </div>
  </div>
);

export default Footer;
